var _g, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 44,
    fill: "none",
    viewBox: "0 0 140 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F96302"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.28 16.42h-5.1L40.88 0 26.3 16.42ZM31.96 16.42h-3.08L40.89 0l-8.93 16.42ZM22.72 30.23h-4.73L1.47 0l21.25 30.23ZM23.5 31.97l-2.27 4.2-2.3-4.2h4.57ZM25.17 28.91 1.47 0l19.7 16.42 4 12.49ZM35.25 20.96l-6.6 1.55-2.2 4.05-2.6-8.1h7.01l4.4 2.5ZM7.82 17.22 0 12.33h5.24l2.58 4.9ZM19.57 37.46 13.32 44l4.25-10.07 2 3.53Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E3B51",
    d: "M55.63 16.1h-8.21c-2.35 0-3.53 1.18-3.53 3.53v4.72c0 2.36 1.18 3.54 3.53 3.54h8.21v-7.07H53.3v4.72h-5.87c-.79 0-1.18-.4-1.18-1.19v-4.72c0-.79.4-1.18 1.18-1.18h8.21v-2.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F96302",
    d: "m51.88 20.82-2.37 2.35h2.37v-2.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E3B51",
    d: "M69.4 20.82v-1.17c0-2.36-1.18-3.54-3.52-3.54h-8.22v11.78h2.35v-3.54h2.55l3.52 3.54h3.33l-3.52-3.54c2.35 0 3.51-1.18 3.51-3.53Zm-2.34 0c0 .79-.4 1.18-1.17 1.18h-5.87v-3.54h5.87c.79 0 1.17.4 1.17 1.19v1.17ZM79.01 15.9h-4.7c-2.35 0-3.53 1.19-3.53 3.54v5.12c0 2.35 1.18 3.54 3.53 3.54H79c2.34 0 3.52-1.19 3.52-3.54v-5.12c0-2.37-1.16-3.54-3.52-3.54Zm1.18 8.64c0 .8-.4 1.19-1.17 1.19h-4.7c-.79 0-1.18-.4-1.18-1.19v-5.11c0-.8.4-1.17 1.18-1.17h4.7c.79 0 1.17.4 1.17 1.17v5.11ZM97.3 16.1l-2.23 7.66-2.3-7.67h-2.44l-2.3 7.67-2.23-7.67h-2.47l3.47 11.79h2.47l2.29-7.66 2.29 7.66h2.47l3.47-11.79H97.3ZM112.97 18.45v-2.36h-11.73v11.79h11.73v-2.36h-9.4v-2.35h7.06v-2.35h-7.05v-2.36h9.4v-.01Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F96302",
    d: "m125.25 18.08 1.5-1.99h-2.95l1.45 2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E3B51",
    d: "m124.6 18.97-1.4-2.05-2.33 3.1-2.94-3.93H115l4.4 5.9-4.4 5.9h2.93l2.94-3.93 2.93 3.93h2.94l-4.4-5.9 2.26-3.02ZM136.4 16.1h-4.69c-2.34 0-3.52 1.16-3.52 3.53v8.25h2.35v-2.36h7.04v2.36h2.35v-8.25c0-2.35-1.18-3.54-3.53-3.54Zm1.18 7.07h-7.04v-3.54c0-.79.39-1.18 1.18-1.18h4.68c.79 0 1.18.4 1.18 1.18v3.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.861ab9eda91eaca2b5f8b8060b30d5bc.svg";
export { ForwardRef as ReactComponent };